<template>
    <div class="remittance-container">
        <head-bar title="转账" :fixed="true"></head-bar>
        <div class="invoice-container">
            <div class="caption-container">
                <div class="caption-left">
                    <span>开票信息</span>
                </div>
                <div class="caption-right">
                    <div
                        class="operation-button"
                        @click="openInvoiceSheet"
                        v-if="hasInvoice"
                    >
                        <span>更改发票资料</span>
                    </div>
                    <div
                        class="operation-button"
                        @click="goToInvoiceEdit"
                        v-if="!hasInvoice"
                    >
                        <span>新增发票资料</span>
                    </div>
                </div>
            </div>
            <div class="invoice_text_list">
                <div
                    class="view_list margin_top_30"
                    v-if="hasDefaultInvoiceInfo"
                >
                    <div class="view_item">
                        <div class="view_label">
                            <span>公司名称</span>
                        </div>
                        <div class="view_text">
                            <span>{{ currentInvoice.companyName }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>开票税号</span>
                        </div>
                        <div class="view_text">
                            <span>{{ currentInvoice.taxNo }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>开户银行</span>
                        </div>
                        <div class="view_text">
                            <span>{{ currentInvoice.depositBank }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>银行帐号</span>
                        </div>
                        <div class="view_text">
                            <span>{{ currentInvoice.bankAccount }}</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>审核状态</span>
                        </div>
                        <div class="view_text">
                            <span>{{ currentInvoice.invoiceStatusDesc }}</span>
                        </div>
                    </div>
                </div>
                <div class="empty_invoice" v-if="!hasDefaultInvoiceInfo">
                    <span>暂无开票信息</span>
                </div>
            </div>
        </div>
        <div class="prompt-container" v-if="hasDefaultInvoiceInfo">
            <span
                >付款账号公司要与开票公司一致，如不一致，请更改开票资料，或用开票公司账号付款。</span
            >
        </div>
        <div class="remittance-info-container">
            <div class="caption-container">
                <div class="caption-left">
                    <span>收款信息</span>
                </div>
                <div class="caption-right">
                    <span>请使用网银或柜台汇款</span>
                </div>
            </div>
            <div class="remittance-text-list">
                <div class="view_list margin_top_30">
                    <div class="view_item">
                        <div class="view_label">
                            <span>收款户名</span>
                        </div>
                        <div class="view_text">
                            <span>深圳市油柑科技有限公司</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>银行卡号</span>
                        </div>
                        <div class="view_text">
                            <span>40000221&nbsp;0920&nbsp;0744&nbsp;484</span>
                        </div>
                    </div>
                    <div class="view_item">
                        <div class="view_label">
                            <span>开户银行</span>
                        </div>
                        <div class="view_text">
                            <span>中国工商银行股份有限公司深圳华强支行</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-group">
            <div class="confrim-button" @click="confirmRemittance">
                <span>我已转账</span>
            </div>
            <div class="later-button" @click="goToOrderInfo">
                <span>稍后转账</span>
            </div>
        </div>
        <!-- 发票 -->
        <van-action-sheet v-model="invoiceSheetVisible" title="发票">
            <div class="invoice-info-box" v-show="hasInvoice">
                <div class="invoice-info-list">
                    <ul class="invoice-info-ul">
                        <li
                            class="invoice-info-item"
                            v-for="(item, index) in invoiceList"
                            :key="index"
                        >
                            <div class="icon">
                                <div class="icon-wrap">
                                    <van-checkbox
                                        checked-color="#4BC227"
                                        v-model="item.selected"
                                        icon-size="20px"
                                        @click="
                                            (checked) =>
                                                invoiceSelectChange(
                                                    checked,
                                                    item
                                                )
                                        "
                                    >
                                    </van-checkbox>
                                </div>
                            </div>
                            <div class="invoice-text">
                                <div class="company-name">
                                    <span>{{
                                        item.companyName | ellipsis(15)
                                    }}</span>
                                    <i
                                        class="default-icon"
                                        v-if="item.isDefault"
                                        >默认</i
                                    >
                                </div>
                                <div class="tax-number">
                                    <span>{{ item.taxNo }}</span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span>{{ item.invoiceStatusDesc }}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group margin-top">
                <div class="btn-item" @click="goToInvoiceEdit">
                    <span>+创建发票信息</span>
                </div>
            </div>
        </van-action-sheet>
        <!-- 发票 -->
    </div>
</template>
<script>
import Vue from "vue";
import { Toast, ActionSheet, Checkbox, Dialog } from "vant";
import HeadBar from "@/components/HeadBar.vue";
import { isEmpty } from "@/utils/validation";
Vue.use(Toast)
    .use(ActionSheet)
    .use(Checkbox)
    .use(Dialog);

let defaultInvoiceInfo = {
    companyName: "",
    taxNo: "",
    depositBank: "",
    bankAccount: "",
    invoiceStatusDesc: "",
};

function getDefaultInvoiceInfo(source, invoiceId) {
    let data = null;
    if (!Array.isArray(source) || source.length === 0) return data;
    source.forEach((item) => {
        if (item.invoiceId == invoiceId) {
            data = { ...item };
        }
    });
    return data;
}

/**
 *
 *
 * @param {array} source 数据列表
 * @description 设置选中属性
 */
function setDefaultSelectedAttrBute(source, invoiceId = 0) {
    if (Array.isArray(source)) {
        return source.map((item) => {
            if (item.invoiceId == invoiceId) {
                item.selected = true;
            } else {
                item.selected = false;
            }
            return item;
        });
    }
}

export default {
    name: "PayOffline",
    components: {
        HeadBar,
    },
    created() {
        let { orderNo } = this.$route.query;
        if (!orderNo) {
            this.$router.push("/");
            return false;
        }
        this.orderNumber = orderNo;
        this.getInvoiceList();
    },
    data() {
        return {
            invoiceSheetVisible: false,
            orderNumber: 0,
            invoiceList: [],
            //是否含有发票
            hasInvoice: false,
            //含有默认发票
            hasDefaultInvoiceInfo: false,
            //当前展示的发票
            currentInvoice: {
                ...defaultInvoiceInfo,
            },
            isLoad: false,
        };
    },
    methods: {
        getInvoiceList() {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(this.$api.userApi.queryInvoiceList, {
                    operation: "select",
                })
                .then((res) => {
                    let { invoiceId } = this.$route.query;
                    let { data: invoiceList = [] } = res;
                    this.hasInvoice = isEmpty(invoiceList) ? false : true;
                    this.invoiceList = invoiceList;
                    if (isEmpty(invoiceId)) {
                        this.hasDefaultInvoiceInfo = false;
                    } else {
                        let invoiceInfo = getDefaultInvoiceInfo(
                            invoiceList,
                            invoiceId
                        );
                        if (invoiceInfo) {
                            this.hasDefaultInvoiceInfo = true;
                            this.currentInvoice = { ...invoiceInfo };
                            this.invoiceList = setDefaultSelectedAttrBute(
                                invoiceList,
                                invoiceId
                            );
                        }
                    }
                })
                .finally((err) => {
                    this.$toast.clear();
                });
        },
        openInvoiceSheet() {
            this.invoiceSheetVisible = true;
        },
        invoiceSelectChange(select, invoiceInfo = {}) {
            if (this.isLoad) return;
            let _this = this;
            let { orderNo } = this.$route.query;
            let { invoiceId, invoiceAddressId = "" } = invoiceInfo;
            let invoiceList = [...this.invoiceList];
            let data = {
                context: {
                    invoiceId,
                    orderNo,
                    invoiceAddressId,
                },
            };
            _this.isLoad = true;
            _this.$axios
                .post(_this.$api.orderApi.order_updateInvoice, {
                    ...data,
                })
                .then((response) => {
                    invoiceList = invoiceList.map((item) => {
                        if (item.invoiceId == invoiceId) {
                            item.selected = true;
                            _this.hasDefaultInvoiceInfo = true;
                            _this.currentInvoice = { ...item };
                        } else {
                            item.selected = false;
                        }
                        return item;
                    });
                    _this.invoiceList = [...invoiceList];
                    _this.invoiceSheetVisible = false;
                })
                .catch(({ msg }) => {
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                })
                .finally(() => {
                    _this.isLoad = false;
                });
        },
        goToInvoiceEdit() {
            let { fullPath } = this.$route;
            this.$router.push({
                path: "/user/invoice/infoEdit",
                query: {
                    from: `${fullPath}`,
                },
            });
        },
        confirmRemittance() {
            if (this.isLoad) false;
            let _this = this;
            let { orderNo } = this.$route.query;
            Dialog.confirm({
                title: "提示",
                message: "是否确认转账?",
                confirmButtonColor: "#4BC227",
            })
                .then(() => {
                    _this.isLoad = true;
                    _this.$axios
                        .post(_this.$api.userApi.uploadPayVoucher, {
                            orderNo: orderNo,
                        })
                        .then(() => {
                            _this.goToOrderInfo();
                        })
                        .catch(({ msg }) => {
                            if (!isEmpty(msg)) {
                                _this.$toast(msg);
                            }
                        })
                        .finally(() => {
                            _this.isLoad = false;
                        });
                })
                .catch(() => {
                    // on cancel
                });
        },
        goToOrderInfo() {
            let { orderNo } = this.$route.query;
            this.$router.push({
                path: "/user/order/detail",
                query: {
                    orderNo: orderNo,
                },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.remittance-container {
    width: 750px;
    padding-top: 92px;

    .margin_top_30 {
        margin-top: 30px;
    }

    .invoice-container {
        margin: 30px auto 0;
        padding: 40px;
        width: 610px;
        background-color: #fff;
        .caption-container {
            height: 60px;
            .caption-left {
                float: left;
                height: 60px;
                width: 305px;
                font-size: 36px;
                line-height: 60px;
                font-weight: 400;
                color: #333333;
            }
            .caption-right {
                float: right;
                height: 60px;
                width: 305px;
                text-align: right;
                .operation-button {
                    display: inline-block;
                    padding: 0 30px;
                    height: 52px;
                    border-radius: 38px;
                    border: 2px solid #dedede;
                    font-size: 24px;
                    font-weight: 400;
                    line-height: 52px;
                    text-align: center;
                    color: #333333;
                }
            }
        }
        .empty_invoice {
            padding: 30px 0 0 0;
            height: 100px;
            font-size: 24px;
            color: #999;
        }
    }

    .prompt-container {
        margin: 0 auto;
        padding: 30px 40px;
        width: 610px;
        background-color: #faf8d9;
        font-size: 24px;
        line-height: 1.5em;
        color: #ff5500;
    }

    .remittance-info-container {
        margin: 30px auto 0;
        padding: 40px;
        width: 610px;
        background-color: #fff;
        .caption-container {
            height: 60px;
            .caption-left {
                float: left;
                height: 60px;
                width: 305px;
                font-size: 36px;
                line-height: 60px;
                font-weight: 400;
                color: #333333;
            }
            .caption-right {
                float: right;
                height: 60px;
                width: 305px;
                font-size: 24px;
                line-height: 60px;
                text-align: right;
                color: #999;
            }
        }
    }

    .view_list {
        width: 610px;
        .view_item {
            overflow: hidden;
            margin: 0 auto;
            padding-bottom: 20px;
            width: 610px;
            .view_label {
                float: left;
                width: 120px;
                font-size: 24px;
                color: #999;
            }
            .view_text {
                float: right;
                width: 485px;
                font-size: 24px;
                color: #333;
            }
        }
    }
    .button-group {
        margin: 40px auto 0;
        width: 690px;
        height: auto;
        .confrim-button {
            width: 690px;
            height: 70px;
            background-color: #4bc227;
            border-radius: 36px;
            font-size: 28px;
            line-height: 70px;
            text-align: center;
            color: #fff;
        }

        .later-button {
            margin: 20px 0 0 0;
            width: 690px;
            height: 70px;
            background-color: #96eb7c;
            border-radius: 36px;
            font-size: 28px;
            line-height: 70px;
            text-align: center;
            color: #fff;
        }
    }
}
.invoice-info-box {
    margin: 0 auto;
    padding: 0 30px;
    width: 690px;
    .invoce-select {
        margin-top: 20px;
        font-size: 0;
        > .select-item {
            *display: inline;
            display: inline-block;
            zoom: 1;
            width: 168px;
            height: 76px;
            border: 1px solid #dedede;
            font-size: 28px;
            line-height: 76px;
            text-align: center;
            &.active {
                border-color: #4bc227;
                background-color: #f3fff0;
                color: #4bc227;
            }
            &.margin-right {
                margin-right: 20px;
            }
        }
    }
    .invoice-info-list {
        margin: 0 auto;
        width: 690px;
        overflow: hidden;
        .invoice-info-ul {
            margin: 0 auto;
            width: 690px;
            .invoice-info-item {
                padding: 40px 0;
                width: 690px;
                overflow: hidden;
                border-bottom: 2px solid #f2f2f2;
                > .icon {
                    position: relative;
                    float: left;
                    width: 100px;
                    .icon-wrap {
                        margin-top: 25px;
                        margin-left: 10px;
                        width: 40px;
                        height: 40px;
                    }
                }
                > .invoice-text {
                    font-size: 24px;
                    width: 580px;
                    float: right;
                    > .company-name {
                        .default-icon {
                            *display: inline;
                            display: inline-block;
                            margin-left: 20px;
                            padding: 2px 10px;
                            background-color: #6ab0f7;
                            font-size: 12px;
                            color: #fff;
                            font-style: normal;
                        }
                    }
                    > .tax-number {
                        padding-top: 22px;
                        color: #999;
                    }
                }
            }
        }
    }
}
.btn-group {
    padding: 0 30px;
    &.margin-top {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .btn-item {
        height: 70px;
        background-color: @theme-color;
        border-radius: 40px;
        line-height: 70px;
        font-size: 28px;
        text-align: center;
        color: #fff;
        &.margin-top {
            margin-top: 20px;
        }
        &.margin-bottom {
            margin-bottom: 20px;
        }
    }
}
</style>
